module.exports = __webpack_public_path__ + "static/media/add_crm.92d8c07c.svg";